document.addEventListener('DOMContentLoaded', () => {
    // 1) Popup elements (guarded)
    const popup = document.querySelector('.video-popup');
    if (!popup) return; // якщо секції/попапа немає на сторінці — просто виходимо без помилок

    const wrapper = popup.querySelector('.video-popup__video-wrapper');
    const closeBtn = popup.querySelector('.video-popup__close');
    const overlay = popup.querySelector('.video-popup__overlay');

    function closePopup() {
        const v = wrapper && wrapper.querySelector('video');
        if (v) {
            v.pause();
            v.src = '';
            v.load();
        }
        if (wrapper) wrapper.innerHTML = '';
        popup.hidden = true;
        document.body.style.overflow = '';
    }

    // safe addEventListener
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    // ESC to close (optional but nice)
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.hidden === false) closePopup();
    });

    // 2) Timeline: підключаємо 1 раз на кожне відео (не на кожен клік!)
    document.querySelectorAll('.video-card__media').forEach((media) => {
        // const video = media.querySelector('video');
        // const progress = media.querySelector('.video-card__progress');
        // if (!video || !progress) return;
        //
        // video.addEventListener('timeupdate', () => {
        //     if (!video.duration) return;
        //     progress.style.height = `${(video.currentTime / video.duration) * 100}%`;
        // });
    });

    // 3) Popup open (delegation — працює і для slick clones)
    document.addEventListener('click', async (e) => {
        const media = e.target.closest('[data-video-popup]');
        if (!media) return;

        const source = media.querySelector('video source');
        if (!source || !wrapper) return;

        // Створюємо popup video без controls, loop, autoplay, зі звуком
        wrapper.innerHTML = `<video class="video-popup__video" autoplay loop playsinline></video>`;
        const popupVideo = wrapper.querySelector('video');

        const srcEl = document.createElement('source');
        srcEl.src = source.src;
        srcEl.type = source.type || 'video/mp4';
        popupVideo.appendChild(srcEl);

        popupVideo.muted = false;
        popupVideo.volume = 1;

        popup.hidden = false;
        document.body.style.overflow = 'hidden';

        try {
            await popupVideo.play();
        } catch (err) {
            // деякі браузери можуть блокувати autoplay зі звуком — але клік зазвичай дозволяє
        }
    });

    // 4) Slick тільки для <= 990px
    const $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    function debounce(fn, wait = 150) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(null, args), wait);
        };
    }

    document.querySelectorAll('.video-cards').forEach((sectionEl) => {
        const $grid = $(sectionEl).find('.video-cards__grid');
        const $dots = $(sectionEl).find('[data-video-dots]');

        function enableSlider() {
            if ($grid.hasClass('slick-initialized')) return;

            $grid.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                infinite: false,
                adaptiveHeight: false,
                appendDots: $dots,
                responsive: [
                    {
                        breakpoint: 769, // 768 і менше
                        settings: { slidesToShow: 2 }
                    }
                ]
            });
        }

        function disableSlider() {
            if (!$grid.hasClass('slick-initialized')) return;
            $grid.slick('unslick');
            $dots.empty();
        }

        function sync() {
            const w = window.innerWidth;
            if (w <= 990) enableSlider();
            else disableSlider();
        }

        sync();
        window.addEventListener('resize', debounce(sync, 200));
    });

    function formatDuration(seconds) {
        if (!seconds || isNaN(seconds)) return '0:00';
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return `${m}:${s.toString().padStart(2, '0')}`;
    }

    document.querySelectorAll('.video-card__media video').forEach(video => {
        const label = video.closest('.video-card__media')?.querySelector('.video-card__duration');
        if (!label) return;

        if (video.readyState >= 1) {
            label.textContent = formatDuration(video.duration);
        } else {
            video.addEventListener('loadedmetadata', () => {
                label.textContent = formatDuration(video.duration);
            }, { once: true });
        }
    });

});
